import { render } from "./InformacionLaboral.vue?vue&type=template&id=1a81cd5d&scoped=true"
import script from "./InformacionLaboral.vue?vue&type=script&lang=js"
export * from "./InformacionLaboral.vue?vue&type=script&lang=js"

import "./InformacionLaboral.vue?vue&type=style&index=0&id=1a81cd5d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a81cd5d"]])

export default __exports__